import { useTranslation } from "react-i18next";
import ToastPopup from "../widgets/Toast/toastPopup";
import phoneNumberLenghth from "./phoneNumberLength";
import countryOptions from "../widgets/countryCodeSelect/countyOption";
import PhoneNumber from "phone";

const useValidation = () => {
  const { t } = useTranslation();

  const validateDepartmentPrice = (data) => {
    const { name, duration, grade, code, opdInternational, opdLocal, opdSubsidized } = data;

    if (!name) {
      ToastPopup.error(t("selDepName"));
      return false;
    }

    if (!duration) {
      ToastPopup.error(t("selDuration"));
      return false;
    }

    if (!grade) {
      ToastPopup.error(t("selGrade"));
      return false;
    }

    if (!code) {
      ToastPopup.error(t("codeRequired"));
      return false;
    }

    if (code.length < 2) {
      ToastPopup.error(t("codeMinLength"));
      return false;
    }

    if (!opdInternational) {
      ToastPopup.error(t("enterOPdInt"));
      return false;
    }

    if (!opdLocal) {
      ToastPopup.error(t("enterOPDLoc"));
      return false;
    }

    if (!opdSubsidized) {
      ToastPopup.error(t("enterOPDSub"));
      return false;
    }

    return true;
  };

  const validateDepartmentSave = (data) => {
    const { departmentName, departmentCode, selectedTimes } = data;
    const trimmedDepartmentName = departmentName.trim();

    if (!trimmedDepartmentName) {
      ToastPopup.error(t("enterDepartmentName"));
      return false;
    }

    if (trimmedDepartmentName.length < 3) {
      ToastPopup.error(t("departmentNameMinLength"));
      return false;
    }

    if (selectedTimes.length === 0) {
      ToastPopup.error(t("selectTime"));
      return false;
    }

    if (!departmentCode) {
      ToastPopup.error(t("departmentCodeRequired"));
      return false;
    }

    if (departmentCode.length < 2) {
      ToastPopup.error(t("departmentCodeMinLength"));
      return false;
    }

    if (departmentCode.length > 4) {
      ToastPopup.error(t("departmentCodeMaxLength"));
      return false;
    }

    return true;
  };

  const getIsoCountryCode = (countryCode) => {
    const country = countryOptions.find((option) => option.value === countryCode);

    return country ? country.flag : "VN";
  };

  const validatePersonalInfo = (info) => {
    const {
      personalPhoneNumber = "",
      personalCountryCode = "",
      officePhoneNumber = "",
      officeCountryCode = "",
      street = "",
      ward = "",
      district = "",
      city = "",
      province = "",
      postalCode = "",
      saveAs = "",
    } = info || {};

    const validateNumber = (number, countryCode, fieldName) => {
      if (!number) {
        // ToastPopup.error(`Please enter ${fieldName}.`);
        ToastPopup.error(t("pleaseEnter", { fieldName }));
        return false;
      }

      const customLengthRanges = {
        84: { min: 9, max: 10 },
      };

      const maxLengthEntry = Object.entries(phoneNumberLenghth).find(([length, codes]) => codes.includes(countryCode));
      const maxLength = maxLengthEntry ? parseInt(maxLengthEntry[0]) : undefined;

      // if (maxLength && (number.length < parseInt(maxLength) || number.length > parseInt(maxLength))) {
      //   ToastPopup.error(`Invalid ${fieldName} length`);
      //   return false;
      // }

      if (customLengthRanges[countryCode]) {
        const { min, max } = customLengthRanges[countryCode];
        if (number.length < min || number.length > max) {
          ToastPopup.error(t("invalidLength", { fieldName }));
          return false;
        }
      } else if (maxLength && (number.length < parseInt(maxLength) || number.length > parseInt(maxLength))) {
        ToastPopup.error(t("invalidLength", { fieldName }));
        return false;
      }

      return true;
    };

    if (!validateNumber(personalPhoneNumber, personalCountryCode, t("phoneNumber"))) return false;
    const isoPhoneCode = getIsoCountryCode(personalCountryCode);

    const phoneNumberValid = PhoneNumber(personalPhoneNumber, {
      country: isoPhoneCode,
    });
    if (!phoneNumberValid.isValid) {
      ToastPopup.error(t("invalidPhoneNumber"));
      return;
    }

    if (officePhoneNumber) {
      if (!validateNumber(officePhoneNumber, officeCountryCode, t("officeNumber"))) return false;
    }

    const isoCountryCode = getIsoCountryCode(officeCountryCode);

    const officeNumberValid = PhoneNumber(officePhoneNumber, {
      country: isoCountryCode,
    });
    if (officePhoneNumber && !officeNumberValid.isValid) {
      ToastPopup.error(t("invalidOfficeNumber"));
      return;
    }

    if (!street) {
      ToastPopup.error(t("enterStreet"));
      return false;
    }

    if (street.length < 1) {
      ToastPopup.error(t("streetMinLength"));
      return false;
    }

    if (!ward) {
      ToastPopup.error(t("enterWard"));
      return false;
    }
    // if (ward.length < 3) {
    //   ToastPopup.error("Ward must be at least 3 characters long.");
    //   return false;
    // }
    // if (!district) {
    //   ToastPopup.error(t("enterDistrict"));
    //   return false;
    // }
    // if (district.length < 1) {
    //   ToastPopup.error(t("districtMinLength"));
    //   return false;
    // }
    if (!city) {
      ToastPopup.error(t("cityReq"));
      return false;
    }
    if (city && city.length < 1) {
      ToastPopup.error(t("cityMinLength"));
      return false;
    }
    if (!province) {
      ToastPopup.error(t("provinceReq"));
      return false;
    }
    if (province && province.length < 1) {
      ToastPopup.error(t("provinceMinLength"));
      return false;
    }
    // if (!postalCode) {
    //   ToastPopup.error('Please enter your postal code.');
    //   return false;
    // }
    if (postalCode && (postalCode.length < 3 || postalCode.length > 10)) {
      ToastPopup.error(t("postalCodeLength"));
      return false;
    }

    if (!saveAs) {
      ToastPopup.error(t("plsSelAddTag"));
      return false;
    }

    return true;
  };

  const validateNationalIdAndPassport = ({ nationalIdNumber, frontNationalIdImage, backNationalIdImage, idType }) => {
    // if (!idType) {
    //   ToastPopup.error(t("selIdType"));
    //   return false;
    // }
    if (!nationalIdNumber) {
      ToastPopup.error(t("plsEntIdNum"));
      return false;
    }
    if (nationalIdNumber.length > 40) {
      ToastPopup.error(t("nationalIDLength"));
      return false;
    }

    if (!frontNationalIdImage) {
      ToastPopup.error(t("frontImageNationalID"));
      return false;
    }

    if (!backNationalIdImage) {
      ToastPopup.error(t("backImageNationalID"));
      return false;
    }
    return true;
  };

  const validateInsurance = (userInsurance, category) => {
    let isValid = true;

    if (userInsurance.length > 0) {
      for (let index = 0; index < userInsurance.length; index++) {
        const item = userInsurance[index];
        if (!item.insurance.company) {
          ToastPopup.error(t("insuranceEntryMissingName", { index: index + 1 }));
          isValid = false;
          break;
        }
        if (!item.insurance.image) {
          ToastPopup.error(t("insuranceEntryMissingImg", { index: index + 1 }));
          isValid = false;
          break;
        }
      }
    }
    if (isValid && !category) {
      ToastPopup.error(t("selCategory"));
      isValid = false;
    }

    return isValid;
  };

  const validateStep1 = (updaatedInfo) => {
    const { firstAndMiddleName, lastName } = updaatedInfo;
    if (!firstAndMiddleName) {
      ToastPopup.error(t("enterFirstName"));
      return false;
    }
    if (!lastName) {
      ToastPopup.error(t("enterLastName"));
      return false;
    }

    return true;
  };

  const isValidURL = (string) => {
    const res = string.match(/(https?:\/\/[^\s]+)/g);
    return res !== null;
  };

  const validateAddArticle = (formData, sections, articleImg, lang) => {
    let isEng;
    if (lang === "EN") {
      isEng = true;
    }
    //for title
    if (!isEng && !formData.title) {
      ToastPopup.error(t("plsEnterTitleEnSel"));
      return false;
    }
    if (!formData.title) {
      ToastPopup.error(t("plsEnterArtTitle"));
      return false;
    }
    if (isEng && !formData.titleVI) {
      ToastPopup.error(t("plsEnterTitleViSel"));
      return false;
    }
    if (!formData.titleVI) {
      ToastPopup.error(t("plsEnterArtTitle"));
      return false;
    }

    //for content
    if (!isEng && !formData.content) {
      ToastPopup.error(t("plsEnterContEnSel"));
      return false;
    }
    if (!formData.content) {
      ToastPopup.error(t("plsEnterArtCont"));
      return false;
    }
    if (isEng && !formData.contentVI) {
      ToastPopup.error(t("plsEnterContViSel"));
      return false;
    }
    if (!formData.contentVI) {
      ToastPopup.error(t("plsEnterArtCont"));
      return false;
    }

    //for category
    if (!isEng && !formData.category) {
      ToastPopup.error(t("plsEnterCategoryEnSel"));
      return false;
    }
    if (!formData.category) {
      ToastPopup.error(t("plsEnterArtCategory"));
      return false;
    }
    if (isEng && !formData.categoryVI) {
      ToastPopup.error(t("plsEnterCategoryViSel"));
      return false;
    }
    if (!formData.categoryVI) {
      ToastPopup.error(t("plsEnterCategory"));
      return false;
    }

    if (!formData.authorName) {
      ToastPopup.error(t("plsEnterAuthor"));
      return false;
    }

    if (!formData.readingTime) {
      ToastPopup.error(t("plsEnterRead"));
      return false;
    }

    if (Number(formData.readingTime) < 1) {
      ToastPopup.error(t("minReadTime"));
      return false;
    }

    if (!formData.referenceEn || !formData.referenceEn.trim()) {
      ToastPopup.error(t("plsEntRef"));
      return false;
    } else if (!isValidURL(formData.referenceEn)) {
      ToastPopup.error(t("validRef"));
      return false;
    }

    if (!formData.referenceVi || !formData.referenceVi.trim()) {
      ToastPopup.error(t("plsEntRef"));
      return false;
    } else if (!isValidURL(formData.referenceVi)) {
      ToastPopup.error(t("validRef"));
      return false;
    }

    if (!formData.websiteName) {
      ToastPopup.error(t("plsEntWebName"));
      return false;
    }

    if (!articleImg) {
      ToastPopup.error(t("plsAddImg"));
      return false;
    }

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const isHeadingFilled = section.title && section.titleVi;
      const isHeadingEmpty = !section.title && !section.titleVi;

      if (!isHeadingFilled && !isHeadingEmpty) {
        if (lang === "EN") {
          if (!section.title) {
            ToastPopup.error(t("plsEntersectionheading", { num: i + 1 }));
          } else {
            ToastPopup.error(t("plsEnterViheading", { num: i + 1 }));
          }
        } else if (lang === "VI") {
          if (!section.titleVi) {
            ToastPopup.error(t("plsEntersectionheading", { num: i + 1 }));
          } else {
            ToastPopup.error(t("plsEnterEnheading", { num: i + 1 }));
          }
        }
        return false;
      }
    }

    if (!sections || sections.length === 0) {
      ToastPopup.error(t("plsAddSec"));
      return false;
    }
    let valid = true;

    sections.forEach((section, index) => {
      let num = index + 1;
      // if (!section.title) {
      //   ToastPopup.error(t("plsEntSecInd", { num }));
      //   valid = false;
      // }
      // if (!isEng && !section.title) {
      //   ToastPopup.error(t("plsEntSecIndEnSel", { num }));
      //   valid = false;
      // }
      // if(!section.titleVi){
      //   ToastPopup.error(t("plsEntSecInd", { num }));
      //   valid = false;
      // }
      // if(isEng && !section.titleVi){
      //   ToastPopup.error(t("plsEntSecIndVnSel", { num }));
      //   valid = false;
      // }
      //for description validations changes
      if (section.contentType.value === "description") {
        if (typeof section.description !== "string" || (section.description.length < 10 && !isEng)) {
          ToastPopup.error(t("minSecConLenEnSel", { num }));
          valid = false;
        } else if (typeof section.description !== "string" || section.description.length < 10) {
          ToastPopup.error(t("minSecConLen", { num }));
          valid = false;
        } else if (typeof section.descriptionVi !== "string" || (section.descriptionVi.length < 10 && isEng)) {
          ToastPopup.error(t("minSecConLenViSel", { num }));
          valid = false;
        } else if (typeof section.descriptionVi !== "string" || section.descriptionVi.length < 10) {
          ToastPopup.error(t("minSecConLen", { num }));
          valid = false;
        }
      }
      // for unorder list validation changes
      else if (section.contentType.value === "unorderedListItem") {
        if ((!isEng && !Array.isArray(section.content)) || section.content.length < 2) {
          ToastPopup.error(t("desErrEnSel", { count: index + 1 }));
          valid = false;
        }
        if (!Array.isArray(section.content) || section.content.length < 2) {
          isEng && ToastPopup.error(t("desErr", { count: index + 1 }));
          valid = false;
        }
        if ((isEng && !Array.isArray(section.contentVi)) || section.contentVi.length < 2) {
          ToastPopup.error(t("desErrViSel", { count: index + 1 }));
          valid = false;
        }
        if (section.content.length !== section.contentVi.length) {
          ToastPopup.error(t("listOrderError", { section: index + 1 }));
          valid = false;
        } else {
          if (section.content) {
            section.content.forEach((item, itemIndex) => {
              if (typeof item !== "string" || (item.length < 1 && isEng)) {
                ToastPopup.error(
                  t("emptySpaceErr", {
                    section: index + 1,
                    item: itemIndex + 1,
                  }),
                );
                valid = false;
              }
            });
          }
          if (section.contentVi) {
            section.contentVi.forEach((item, itemIndex) => {
              if (typeof item !== "string" || item.length < 1) {
                ToastPopup.error(
                  t("emptySpaceErrVi", {
                    section: index + 1,
                    item: itemIndex + 1,
                  }),
                );
                valid = false;
              }
            });
          }
        }
        if (!Array.isArray(section.contentVi) || section.contentVi.length < 2) {
          !isEng && ToastPopup.error(t("desErr", { count: index + 1 }));
          valid = false;
        } else {
          if (section.content) {
            section.content.forEach((item, itemIndex) => {
              if (typeof item !== "string" || (item.length < 1 && isEng)) {
                ToastPopup.error(t("emptySpaceErr", { section: index + 1, item: itemIndex + 1 }));
                valid = false;
              }
              if ((isEng && typeof item !== "string") || item.length < 1) {
                ToastPopup.error(
                  t("emptySpaceErr", {
                    section: index + 1,
                    item: itemIndex + 1,
                  }),
                );
                valid = false;
              }
            });
          }
          if (section.content) {
            section.contentVi.forEach((item, itemIndex) => {
              if (typeof item !== "string" || item.length < 1) {
                ToastPopup.error(
                  t("emptySpaceErrVi", {
                    section: index + 1,
                    item: itemIndex + 1,
                  }),
                );
                valid = false;
              }
              if ((!isEng && typeof item !== "string") || item.length < 1) {
                ToastPopup.error(
                  t("emptySpaceErrVi", {
                    section: index + 1,
                    item: itemIndex + 1,
                  }),
                );
                valid = false;
              }
            });
          }
        }
      }
    });

    return valid;
  };

  const validateEditArticle = (articleData, lang) => {
    let isEng;
    if (lang === "en") {
      isEng = true;
    }
    if (!isEng && !articleData.en.title) {
      ToastPopup.error(t("plsEnterTitleEnSel"));
      return false;
    }
    if (!articleData.en.title) {
      ToastPopup.error(t("plsEnterTitle"));
      return false;
    }
    if (!isEng && !articleData.en.content) {
      ToastPopup.error(t("plsEnterContEnSel"));
      return false;
    }
    if (!articleData.en.content) {
      ToastPopup.error(t("plsEnterCont"));
      return false;
    }
    if (!isEng && !articleData.en.category) {
      ToastPopup.error(t("plsEnterCategoryEnSel"));
      return false;
    }
    if (!articleData.en.category) {
      ToastPopup.error(t("plsEnterArtCategory"));
      return false;
    }
    if (!articleData.author) {
      ToastPopup.error(t("plsEnterAuthor"));
      return false;
    }

    if (!articleData.readingTime) {
      ToastPopup.error(t("plsEnterRead"));
      return false;
    }

    if (Number(articleData.readingTime) < 1) {
      ToastPopup.error(t("minReadTime"));
      return false;
    }

    if (!articleData.reference || !articleData.reference.en || !articleData.reference.en.trim()) {
      ToastPopup.error(t("plsEntRef"));
      return false;
    } else if (!isValidURL(articleData.reference.en)) {
      ToastPopup.error(t("validRef"));
      return false;
    }

    if (!articleData.reference || !articleData.reference.vi || !articleData.reference.vi.trim()) {
      ToastPopup.error(t("plsEntRef"));
      return false;
    } else if (!isValidURL(articleData.reference.vi)) {
      ToastPopup.error(t("validRef"));
      return false;
    }

    if (!articleData.websiteName) {
      ToastPopup.error(t("plsEntWebName"));
      return false;
    }

    if (!articleData.coverImage) {
      ToastPopup.error(t("plsAddImg"));
      return false;
    }

    if (isEng && !articleData.vi.title) {
      ToastPopup.error(t("plsEnterTitleViSel"));
      return false;
    }
    if (!articleData.vi.title) {
      ToastPopup.error(t("plsEnterTitle"));
      return false;
    }
    if (isEng && !articleData.vi.content) {
      ToastPopup.error(t("plsEnterContViSel"));
      return false;
    }
    if (!articleData.vi.content) {
      ToastPopup.error(t("plsEnterCont"));
      return false;
    }
    if (isEng && !articleData.vi.category) {
      ToastPopup.error(t("plsEnterCategoryViSel"));
      return false;
    }
    if (!articleData.vi.category) {
      ToastPopup.error(t("plsEnterCategory"));
      return false;
    }

    const enSections = articleData.en.additionalContent?.sections || [];
    const viSections = articleData.vi.additionalContent?.sections || [];

    if (enSections.length === 0 || viSections.length === 0) {
      ToastPopup.error(t("plsAddSec"));
      return false;
    }
    for (let i = 0; i < Math.max(enSections.length, viSections.length); i++) {
      const enHeading = enSections[i]?.title?.trim();
      const viHeading = viSections[i]?.title?.trim();

      const isHeadingFilled = enHeading && viHeading;
      const isHeadingEmpty = !enHeading && !viHeading;

      if (!isHeadingFilled && !isHeadingEmpty) {
        if (lang === "en") {
          if (!enHeading) {
            ToastPopup.error(t("plsEntersectionheading", { num: i + 1 }));
          } else {
            ToastPopup.error(t("plsEnterViheading", { num: i + 1 }));
          }
        } else if (lang === "vi") {
          if (!viHeading) {
            ToastPopup.error(t("plsEntersectionheading", { num: i + 1 }));
          } else {
            ToastPopup.error(t("plsEnterEnheading", { num: i + 1 }));
          }
        }
        return false;
      }
    }

    let valid = true;

    articleData.vi.additionalContent.sections.forEach((section, index) => {
      let num = index + 1;
      // if (!section.title) {
      //   ToastPopup.error(t("plsEntSecInd", { num }));
      //   valid = false;
      // }

      if (section.content && section.content.length > 0) {
        if (section.content.length < 2) {
          if (isEng) {
            ToastPopup.error(t("chngSecLeastTwoItemVi", { num }));
          } else {
            ToastPopup.error(t("secLeastTwoItem", { num }));
          }
        }
        if (!Array.isArray(section.content) || section.content.length < 2) {
          if (isEng) {
            ToastPopup.error(t("chngSecLeastTwoItemVi", { num }));
          } else {
            ToastPopup.error(t("secLeastTwoItem", { num }));
          }
          return (valid = false);
        } else {
          section.content.forEach((item, itemIndex) => {
            if (typeof item !== "string" || item.length < 1) {
              ToastPopup.error(t("secListNotEmtpy", { num: num, i: itemIndex + 1 }));
              return (valid = false);
            }
          });
        }
      } else {
        if (!section.description || section.description.length === 0) {
          if (isEng) {
            ToastPopup.error(t("chngEntSecDesVi", { num }));
          } else {
            ToastPopup.error(t("entSecDes", { num }));
          }
          return (valid = false);
        } else if (section.description && section.description.length < 10) {
          ToastPopup.error(t("minSecConLen", { num }));
          valid = false;
        }
      }
    });

    articleData.en.additionalContent.sections.forEach((section, index) => {
      let num = index + 1;
      if (section.content && section.content.length > 0) {
        if (section.content.length < 2) {
          if (!isEng) {
            ToastPopup.error(t("chngSecLeastTwoItem", { num }));
          } else {
            ToastPopup.error(t("secLeastTwoItem", { num }));
          }
        }
        if (!Array.isArray(section.content) || section.content.length < 2) {
          if (!isEng) {
            ToastPopup.error(t("chngSecLeastTwoItem", { num }));
          } else {
            ToastPopup.error(t("secLeastTwoItem", { num }));
          }
          return (valid = false);
        } else {
          section.content.forEach((item, itemIndex) => {
            if (typeof item !== "string" || item.length < 1) {
              ToastPopup.error(t("secListNotEmtpy", { num: num, i: itemIndex + 1 }));
              return (valid = false);
            }
          });
        }
      } else {
        if (!section.description || section.description.length === 0) {
          if (!isEng) {
            ToastPopup.error(t("chngEntSecDes", { num }));
          } else {
            ToastPopup.error(t("entSecDes", { num }));
          }
          return (valid = false);
        } else if (section.description && section.description.length < 10) {
          ToastPopup.error(t("minSecConLen", { num }));
          return (valid = false);
        }
      }
    });

    return valid;
  };

  const validateEditConsumable = (body) => {
    if (!body.itemName || (!body.itemName.en && !body.itemName.vi)) {
      ToastPopup.error(t("plsEntItemName"));
      return false;
    }
    if (!body.numberOfPcs) {
      ToastPopup.error(t("plsEntNoOfPcs"));
      return false;
    }
    if (!body.price.opdInternationalPrice) {
      ToastPopup.error(t("enterOPdInt"));
      return false;
    }

    if (!body.price.opdLocalPrice) {
      ToastPopup.error(t("enterOPDLoc"));
      return false;
    }

    if (!body.price.opdSubsidized) {
      ToastPopup.error(t("enterOPDSub"));
      return false;
    }
    return true;
  };
  const validateCreateConsumable = (body) => {
    if (!body.group) {
      ToastPopup.error(t("plsSelGrp"));
      return false;
    }
    if (!body.code) {
      ToastPopup.error(t("plsEntCode"));
      return false;
    }
    if (!body.itemName || (!body.itemName.en && !body.itemName.vi)) {
      ToastPopup.error(t("plsEntItemName"));
      return false;
    }
    if (!body.stockUOM) {
      ToastPopup.error(t("plsSelStockUom"));
      return false;
    }
    if (!body.numberOfPcs) {
      ToastPopup.error(t("plsEntNoOfPcs"));
      return false;
    }
    if (!body.price.opdInternationalPrice) {
      ToastPopup.error(t("enterOPdInt"));
      return false;
    }

    if (!body.price.opdLocalPrice) {
      ToastPopup.error(t("enterOPDLoc"));
      return false;
    }

    if (!body.price.opdSubsidized) {
      ToastPopup.error(t("enterOPDSub"));
      return false;
    }
    return true;
  };
  const validateCretaeNurse = (nurseData, serviceGroup) => {
    if (!nurseData.firstName?.en) {
      ToastPopup.error(t("pleaseEnterFirstNameEn"));
      return false;
    }
    if (!nurseData.firstName?.vi) {
      ToastPopup.error(t("pleaseEnterFirstNameVi"));
      return false;
    }
    if (!nurseData.lastName?.en) {
      ToastPopup.error(t("pleaseEnterLastNameEn"));
      return false;
    }
    if (!nurseData.lastName?.vi) {
      ToastPopup.error(t("pleaseEnterLastNameVi"));
      return false;
    }
    // passport removed from UI and validation
    if (!nurseData.email) {
      ToastPopup.error(t("pleaseEnterEmail"));
      return false;
    }
    if (!nurseData.email.endsWith(".com")) {
      ToastPopup.error(t("pleaseEnterValidEmail"));
      return false;
    }

    if (!nurseData.employeeID) {
      ToastPopup.error(t("pleaseEnterEmployeeId"));
      return false;
    }
    if (!nurseData.phoneNumber) {
      ToastPopup.error(t("pleaseEnterPhoneNumber"));
      return false;
    }
    if (!nurseData.dateOfBirth) {
      ToastPopup.error(t("pleaseEnterDateOfBirth"));
      return false;
    }
    if (!nurseData.gender) {
      ToastPopup.error(t("pleaseSelectGender"));
      return false;
    }
    if (!nurseData.languages || nurseData.languages.length === 0) {
      ToastPopup.error(t("pleaseSelectLanguage"));
      return false;
    }
    if (!nurseData.designation?.en) {
      ToastPopup.error(t("pleaseEnterJobTitleEn"));
      return false;
    }
    if (!nurseData.designation?.vi) {
      ToastPopup.error(t("pleaseEnterJobTitleVi"));
      return false;
    }
    if (!nurseData.address?.en) {
      ToastPopup.error(t("pleaseEnterAddressEn"));
      return false;
    }
    if (!nurseData.address?.vi) {
      ToastPopup.error(t("pleaseEnterAddressVi"));
      return false;
    }
    if (serviceGroup.selectedServiceGroups.length === 0) {
      ToastPopup.error(t("pleaseSelectServiceGroupSpec"));
      return false;
    }
    if (serviceGroup.selectedSubServiceGroups.length === 0) {
      ToastPopup.error(t("pleaseSelectSubServiceGroupSpec"));
      return false;
    }
    if (serviceGroup.selectedServiceItems.length === 0) {
      ToastPopup.error(t("pleaseSelectServiceItemsSpec"));
      return false;
    }
    return true;
  };
  const validateEditNurse = (formData, serviceGroups) => {
    if (!formData.firstName?.en) {
      ToastPopup.error(t("pleaseEnterFirstNameEn"));
      return false;
    }
    if (!formData.firstName?.vi) {
      ToastPopup.error(t("pleaseEnterFirstNameVi"));
      return false;
    }
    if (!formData.lastName?.en) {
      ToastPopup.error(t("pleaseEnterLastNameEn"));
      return false;
    }
    if (!formData.lastName?.vi) {
      ToastPopup.error(t("pleaseEnterLastNameVi"));
      return false;
    }
    // passport removed from UI and validation
    if (!formData.email) {
      ToastPopup.error(t("pleaseEnterEmail"));
      return false;
    }
    if (!formData.employeeId) {
      ToastPopup.error(t("pleaseEnterEmployeeId"));
      return false;
    }
    if (!formData.phoneNumber) {
      ToastPopup.error(t("pleaseEnterPhoneNumber"));
      return false;
    }
    if (!formData.dateOfBirth) {
      ToastPopup.error(t("pleaseEnterDateOfBirth"));
      return false;
    }
    if (!formData.gender) {
      ToastPopup.error(t("pleaseSelectGender"));
      return false;
    }
    if (!formData.languages || formData.languages.length === 0) {
      ToastPopup.error(t("pleaseSelectLanguage"));
      return false;
    }
    if (!formData.designation?.en) {
      ToastPopup.error(t("pleaseEnterJobTitleEn"));
      return false;
    }
    if (!formData.designation?.vi) {
      ToastPopup.error(t("pleaseEnterJobTitleVi"));
      return false;
    }
    if (!formData.address?.en) {
      ToastPopup.error(t("pleaseEnterAddressEn"));
      return false;
    }
    if (!formData.address?.vi) {
      ToastPopup.error(t("pleaseEnterAddressVi"));
      return false;
    }
    if (serviceGroups.selectedServiceGroups.length === 0) {
      ToastPopup.error(t("pleaseSelectServiceGroupSpec"));
      return false;
    }
    if (serviceGroups.selectedSubServiceGroups.length === 0) {
      ToastPopup.error(t("pleaseSelectSubServiceGroupSpec"));
      return false;
    }
    if (serviceGroups.selectedServiceItems.length === 0) {
      ToastPopup.error(t("pleaseSelectServiceItemsSpec"));
      return false;
    }
    return true; // Return true if all validations pass
  };

  return {
    validateDepartmentPrice,
    validateDepartmentSave,
    validatePersonalInfo,
    validateNationalIdAndPassport,
    validateInsurance,
    validateStep1,
    validateAddArticle,
    validateEditArticle,
    validateEditConsumable,
    validateCreateConsumable,
    validateCretaeNurse,
    validateEditNurse,
  };
};

export default useValidation;
